export default "__VITE_ASSET__CNpdF87G__"